
export default {
  title: 'Job List',
  talent: 'Talent',
  opportunity: 'Opportunity',
  viewJobs: 'View Jobs',
  notSpecified: 'Not Specified',
  multiLocations: 'Multi-locations',
  internalJob: 'Internal Only',
  externalJob: 'External Only',
  tip: {
    noJobMatched: 'Oops! No jobs are matched.',
    tryOtherKeywords: 'Please try other keywords :)',
    groupJobTips: '*You may only apply to ONE (1) graduate position at Ford. Select carefully! All applications MUST be submitted in ENGLISH.'
  },
  label: {
    referralRewards: 'Referral Rewards',
    availableJobs: 'Available jobs',
    openJobCount: 'Total {count} job(s) open',
    locationsText: '{city} <span class="num">{count}</span> addresses',
    locationsTitleText: '{city} {count} addresses',
    detailPageTitleText: '{name} | Seeking Talent Like You!'
  },
  btn: {
    winRewards: 'WIN REWARDS',
    search: 'Search',
    apply: 'Apply',
    reapply: 'Reapply',
    applied: 'Applied',
    continueFinishApply: 'Continue Finish Apply',
    follow: 'Follow',
    stopFollowing: 'Stop Following'
  },
  message: {
    multipleJobs: 'Multiple Jobs',
    multipleLocations: 'Multiple Locations'
  }
}
